import { render, staticRenderFns } from "./ProuniFamilyIncome.vue?vue&type=template&id=e8c806f2&"
import script from "./ProuniFamilyIncome.vue?vue&type=script&lang=ts&"
export * from "./ProuniFamilyIncome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports